import React, { PureComponent } from 'react';

import { Container, filterProps } from '@lglp/components';
import { compose } from 'ramda';

import { linkFileExtension, linkFileSize } from '../../../helpers/media';
import { toMediaPrismic } from '../../../schema/prismic/mapping';
import { COMMON } from '../../../translations';
import { DownloadIcon } from '../../icons';
import { translate } from '../../mixins/composer';
import { withTrackingEvent } from '../../mixins/seo';
import Link from './Link';

export class DownloadMediaLinkComponent extends PureComponent {
  static displayName = 'DownloadMediaLinkComponent';

  static handledProps = ['document', 'track'];

  render() {
    const { t, lang, track, document } = this.props;
    const rest = filterProps(DownloadMediaLinkComponent, this.props);
    const { mediaType, title, link, downloadUrl } = document || {};

    return (
      <Link
        to={downloadUrl || link?.url}
        download
        onClick={track({
          categoryGA: 'MediaDownload',
          actionGA: toMediaPrismic(mediaType),
          labelGA: title,
        })}
        {...rest}
      >
        <Container className="download-1">
          <span className="link-text">{t(COMMON.DOWNLOAD)}</span>
          {link && (
            <span className="link-weight">
              {[linkFileExtension(link), linkFileSize(lang)(link)]
                .filter(Boolean)
                .join(' - ')}
            </span>
          )}
        </Container>
        <Container className="download-2">
          <DownloadIcon />
        </Container>
      </Link>
    );
  }
}

const enhanced = compose(translate, withTrackingEvent);

export default enhanced(DownloadMediaLinkComponent);
